import { type MCPServerInfo } from '../../types';

const StripeServer: MCPServerInfo = {
  serverId: 'STRIPE',
  name: 'Stripe',
  slug: 'stripe',
  description: 'Interact with Stripe services over the Stripe API.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.stripe.com'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default StripeServer;
